module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"simbad":"SIMBAD","ned":"NED"},"ja":{"simbad":"SIMBAD","ned":"NED"}}')
  delete Component.options._Ctor
}
